import { render, staticRenderFns } from "./DataBadge.vue?vue&type=template&id=15016cd8&scoped=true"
import script from "./DataBadge.vue?vue&type=script&lang=js"
export * from "./DataBadge.vue?vue&type=script&lang=js"
import style0 from "./DataBadge.vue?vue&type=style&index=0&id=15016cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15016cd8",
  null
  
)

export default component.exports